export const setJobReferenceValueToFormField = () => {
  const jobOffer = document.querySelectorAll('.js-job-offer');
  jobOffer.forEach((jobOffer) => {
    const reference = jobOffer.getAttribute('data-reference');
    const email = jobOffer.getAttribute('data-email');
    const title = jobOffer.getAttribute('data-title');
    const formReferenceField = jobOffer.querySelector('.job_reference');
    const destinationEmailField = jobOffer.querySelector('.destination_email');
    const titleEmailField = jobOffer.querySelector('.title');
    if (formReferenceField) {
      formReferenceField.value = reference;
    }
    if (destinationEmailField) {
      destinationEmailField.value = email;
    }
    if (titleEmailField) {
      titleEmailField.value = title;
    }
  });
};

export default {
  init() {
    const expandJobOfferOnPageLoad = () => {
      const queryHash = window.location.hash;
      if (!queryHash) return;
      const id = queryHash.slice(1);
      const jobOffer = document.getElementById(id);
      if (jobOffer) {
        jobOffer.open = true;
        scrollBy(0, -100);
      }
    };
    expandJobOfferOnPageLoad();

    

    setJobReferenceValueToFormField();
  },
};
